export default __webpack_public_path__ + "static/media/blue-ball.39dc4928.svg";